export default __webpack_public_path__ + "4da1371e473deab5ab532d36037ad66e.jpg";